const captionRegex = /image caption:/i;

class RteContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.querySelector('#bloggy--article')) return;

    if (this.hasAttribute("unwrap-images")) {
      this.querySelectorAll("* > img:only-child").forEach(img => {
        img.parentNode.outerHTML = img.outerHTML;
      });
    }

    if (this.hasAttribute("format-captions")) {
      [...this.children].forEach((child) => {
        if (captionRegex.test(child.innerHTML)) {
          child.outerHTML = `
            <div class="rte-image-caption">${child.innerHTML.replace(
            captionRegex,
            ""
          )}</div>
          `;
        }
      });
    }
  }
}

if (!customElements.get("rte-content")) {
  customElements.define("rte-content", RteContent);
}
